// assets
import { IconBriefcase, IconUsersGroup, IconFileText, IconUserCheck, IconUserMinus, IconCalendarUser } from '@tabler/icons-react';

// constant
const icons = {
  IconBriefcase,
  IconUsersGroup,
  IconUserCheck,
  IconUserMinus,
  IconFileText,
  IconCalendarUser
};

// ==============================|| RECRUITMENT MENU ITEMS ||============================== //

const recruitment = {
  id: 'recruitment',
  title: 'Recruitment',
  type: 'group',
  children: [
    {
      id: 'jobs',
      title: 'Jobs',
      type: 'item',
      url: '/jobs',
      icon: icons.IconBriefcase,
      breadcrumbs: false
    },
    {
      id: 'candidates',
      title: 'Candidates',
      type: 'item',
      url: '/candidates',
      icon: icons.IconUsersGroup,
      breadcrumbs: false
    },
    // {
    //   id: 'interviews',
    //   title: 'Interviews',
    //   type: 'item',
    //   url: '/interviews',
    //   icon: icons.IconCalendarUser,
    //   breadcrumbs: false
    // },
   
    {
      id: 'onboarding',
      title: 'Onboarding',
      type: 'item',
      url: '/onboarding',
      icon: icons.IconUserCheck,
      breadcrumbs: false
    },
  ]
};

export default recruitment;
